import { AxiosInstance } from 'axios';
import { PaymentAccountRef } from './refs';
import { SyncPaymentAccountInput } from './inputs';
import { PaymentAccountResource, PaymentAccountSetupIntentResource } from './resources';

export default class PaymentAccount {
    private basePath = '/api/payment-account';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Force-sync payment account data from external provider
    sync = async (input: SyncPaymentAccountInput): Promise<PaymentAccountRef> => {
        const { data } = await this.http.post(`${this.basePath}/sync`, input);

        return data;
    };

    // Get payment account, associated with user
    getPaymentAccountAssociatedWithUser = async (user_id: ID): Promise<PaymentAccountResource> => {
        const { data } = await this.http.get(`${this.basePath}/user/${user_id}`);

        return data;
    };

    // Get payment account, associated with workspace
    getPaymentAccountAssociatedWithWorkspace = async (workspace_id: ID): Promise<PaymentAccountResource> => {
        const { data } = await this.http.get(`${this.basePath}/workspace/${workspace_id}`);

        return data;
    };

    // Create setup intent for the account
    createSetupIntent = async (id: ID): Promise<PaymentAccountSetupIntentResource> => {
        const { data } = await this.http.post(`${this.basePath}/${id}/setup-intent`);

        return data;
    };
}
